export default "__VITE_ASSET__DVu7pTqv__"